import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share_light",
  "use": "icon-share_light-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"icon-share_light\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-5-5.4h44v44H-5z\" /><path d=\"M13.333.1v3.667H4.167v25.666h25.666v-9.166H33.5v11c0 1.012-.82 1.833-1.833 1.833H2.333A1.833 1.833 0 0 1 .5 31.267V1.933C.5.921 1.32.1 2.333.1h11Zm13.908 3.667h-8.408V.1H33.5v14.667h-3.667V6.359L17 19.192 14.408 16.6 27.24 3.767Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol